import { useState } from "react";
import {
  RiArrowLeftLine,
  RiFileTextLine,
  RiDownloadLine,
  RiMailLine,
  RiSearchLine,
} from "react-icons/ri";
import { useNavigate } from "react-router-dom";

const InvoiceHistory = () => {
  const navigate = useNavigate();
  const [invoices, setInvoices] = useState([
    {
      id: 1,
      invoiceNumber: "INV-2024-001",
      customerName: "Tech Solutions Inc",
      amount: 2499.99,
      issueDate: "2024-02-15",
      dueDate: "2024-03-15",
      status: "Paid",
    },
    {
      id: 2,
      invoiceNumber: "INV-2024-002",
      customerName: "Design Agency Inc",
      amount: 1899.99,
      issueDate: "2024-02-20",
      dueDate: "2024-03-20",
      status: "Pending",
    },
    {
      id: 3,
      invoiceNumber: "INV-2024-003",
      customerName: "Marketing Pro LLC",
      amount: 3299.99,
      issueDate: "2024-02-25",
      dueDate: "2024-03-25",
      status: "Overdue",
    },
  ]);

  const getStatusColor = (status) => {
    switch (status) {
      case "Paid":
        return "bg-green-100 text-green-800";
      case "Pending":
        return "bg-yellow-100 text-yellow-800";
      case "Overdue":
        return "bg-red-100 text-red-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  return (
    <div className="max-w-full mx-auto space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <button
            onClick={() => navigate("/billing")}
            className="p-2 hover:bg-gray-100 rounded-lg text-gray-600 transition-colors"
          >
            <RiArrowLeftLine className="w-5 h-5" />
          </button>
          <h1 className="text-3xl font-bold text-gray-900">Invoice History</h1>
        </div>
        <div className="relative">
          <RiSearchLine className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Search invoices..."
            className="pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
          />
        </div>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="card bg-white">
          <h3 className="text-lg font-semibold text-gray-900">
            Total Invoiced
          </h3>
          <p className="text-2xl font-bold text-primary-600 mt-2">$7,699.97</p>
          <p className="text-sm text-gray-500 mt-1">3 invoices</p>
        </div>
        <div className="card bg-white">
          <h3 className="text-lg font-semibold text-gray-900">Paid</h3>
          <p className="text-2xl font-bold text-green-600 mt-2">$2,499.99</p>
          <p className="text-sm text-gray-500 mt-1">1 invoice</p>
        </div>
        <div className="card bg-white">
          <h3 className="text-lg font-semibold text-gray-900">Pending</h3>
          <p className="text-2xl font-bold text-yellow-600 mt-2">$1,899.99</p>
          <p className="text-sm text-gray-500 mt-1">1 invoice</p>
        </div>
        <div className="card bg-white">
          <h3 className="text-lg font-semibold text-gray-900">Overdue</h3>
          <p className="text-2xl font-bold text-red-600 mt-2">$3,299.99</p>
          <p className="text-sm text-gray-500 mt-1">1 invoice</p>
        </div>
      </div>

      {/* Invoices Table */}
      <div className="card">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b">
                <th className="text-left py-4 px-4">Invoice Number</th>
                <th className="text-left py-4 px-4">Customer</th>
                <th className="text-left py-4 px-4">Amount</th>
                <th className="text-left py-4 px-4">Issue Date</th>
                <th className="text-left py-4 px-4">Due Date</th>
                <th className="text-left py-4 px-4">Status</th>
                <th className="text-right py-4 px-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {invoices.map((invoice) => (
                <tr key={invoice.id} className="border-b">
                  <td className="py-4 px-4">
                    <div className="flex items-center gap-2">
                      <RiFileTextLine className="text-gray-400" />
                      {invoice.invoiceNumber}
                    </div>
                  </td>
                  <td className="py-4 px-4">{invoice.customerName}</td>
                  <td className="py-4 px-4">${invoice.amount}</td>
                  <td className="py-4 px-4">
                    {new Date(invoice.issueDate).toLocaleDateString()}
                  </td>
                  <td className="py-4 px-4">
                    {new Date(invoice.dueDate).toLocaleDateString()}
                  </td>
                  <td className="py-4 px-4">
                    <span
                      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(
                        invoice.status,
                      )}`}
                    >
                      {invoice.status}
                    </span>
                  </td>
                  <td className="py-4 px-4">
                    <div className="flex justify-end gap-2">
                      <button
                        title="Download"
                        className="p-2 hover:bg-gray-100 rounded-lg text-gray-600"
                      >
                        <RiDownloadLine className="w-5 h-5" />
                      </button>
                      <button
                        title="Send Email"
                        className="p-2 hover:bg-gray-100 rounded-lg text-gray-600"
                      >
                        <RiMailLine className="w-5 h-5" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default InvoiceHistory;
